import React, { useEffect, useRef, useState } from 'react';
import { pick } from 'ramda';
import { Icon } from 'js/components/common/Icon';
import { useUserSelector } from 'js/store/hooks';
import { useFormatter } from 'js/hooks/useFormatter';
import { getClassNames } from 'js/utils/classNames.util';
import { componentService } from 'js/services/component.service';

import * as style from './SessionTicker.scss';

export const SessionTicker = ({ className = '', classname = '' }) => {
    const { isLoggedIn, sessionStartTime } = useUserSelector(pick(['isLoggedIn', 'sessionStartTime']));
    const [sessionTime, setSessionTime] = useState(0);
    const ticker = useRef();
    const formatter = useFormatter();

    useEffect(() => {
        const updateTicker = () => {
            const currentSessionTime = new Date() - sessionStartTime;
            const delay = 1000 - currentSessionTime % 1000;
            setSessionTime(currentSessionTime);

            ticker.current = setTimeout(updateTicker, delay);
        };

        if (isLoggedIn) {
            updateTicker();
        } else {
            clearTimeout(ticker.current);
        }

        return () => {
            clearTimeout(ticker.current);
        };
    }, [isLoggedIn, sessionStartTime]);

    if (!isLoggedIn) {
        return null;
    }

    return (
        <span className={getClassNames([style.sessionTicker, className, classname])}>
            <Icon type="hourglass" />
            {formatter.getDurationTimeLong(sessionTime)}
        </span>
    );
};

componentService.registerWebContentComponents({ SessionTicker });
